import { render, staticRenderFns } from "./uploadGetData.vue?vue&type=template&id=2a44f109&scoped=true"
import script from "./uploadGetData.vue?vue&type=script&lang=js"
export * from "./uploadGetData.vue?vue&type=script&lang=js"
import style0 from "./uploadGetData.vue?vue&type=style&index=0&id=2a44f109&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a44f109",
  null
  
)

export default component.exports